<app-navbar title="Comunicados" />

<div class="container m-auto py-8 px-4 overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)]">
  <app-card>
    <app-card-header title="Comunicados" />
    <app-table-announcements
      [loading]="loading()"
      (view)="openDialog($event)"
    />
  </app-card>
</div>

<p-dialog
  [(visible)]="announcementDialog"
  [maximizable]="true"
  [modal]="true"
  [style]="{ width: '52rem' }"
  [closable]="true"
>
  <ng-template #header>
    <div class="w-full items-center justify-center">
      <h1 class="text-2xl text-zinc-900 font-bold">{{ announcementDialogTitle() }}</h1>
    </div>
  </ng-template>

  <form [formGroup]="announcementForm" (submit)="submitDialog()" class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="flex flex-col justify-start gap-1">
      <div class="text-zinc-900 font-semibold">Assunto</div>
      <div class="text-zinc-500">{{ announcementForm.get('subject')?.value || '---' }}</div>
    </div>
    <div class="flex flex-col justify-start gap-1">
      <div class="text-zinc-900 font-semibold">Recebido em</div>
      <div class="text-zinc-500">{{ announcementForm.get('created_at')?.value | date: 'dd/MM/y' }}</div>
    </div>
    <div class="flex flex-col justify-start gap-1 col-span-2">
      <div class="text-zinc-900 font-semibold">Descrição</div>
      <div class="text-zinc-500">{{ announcementForm.get('message')?.value || '---' }}</div>
    </div>
    <div class="flex flex-col justify-start gap-1 col-span-2">
      <div class="text-zinc-900 font-semibold">Arquivos adicionados ({{ announcementForm.get('attachments')?.value.length || 0 }})</div>
      <div class="flex flex-wrap items-center justify-start gap-4">
        @for (attachment of announcementForm.get('attachments')?.value; track $index) {
          <div
            class="w-auto flex items-center justify-start gap-2 rounded border border-zinc-300 p-2 cursor-pointer hover:bg-zinc-50"
            (click)="openFile(attachment.path_url)"
          >
            <i class="fa-solid fa-file"></i>
            <span class="text-zinc-500">{{ attachment.title }}</span>
          </div>
        }
      </div>
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2">
      <label for="answer" class="font-semibold">Resposta</label>
      <input
        pInputText
        id="answer"
        formControlName="answer"
        placeholder="Digite sua resposta..."
        fluid
        autocomplete="off"
        [invalid]="announcementForm.get('answer')?.dirty && announcementForm.get('answer')?.errors"
        [disabled]="loading()"
      />
    </div>

    <div class="col-span-2">
      <p-divider />
    </div>

    <div class="col-span-2">
      <h2 class="text-2xl text-zinc-900 font-bold">Notas</h2>
    </div>

    <div class="col-span-2 rounded-lg border border-gray-300 p-4 flex flex-col items-start justify-start gap-4 divide-y divide-zinc-300">
      <div class="w-full font-semibold text-zinc-900">
        <i class="fa-solid fa-file"></i>
        Notas
      </div>
      @for (note of announcementForm.get('notes')?.value; track $index) {
        <div class="w-full pb-3">
          <div class="w-full flex items-start justify-between">
            <div class="flex items-center justify-start gap-2">
              <!-- <div>Logo</div> -->
              <div class="flex flex-col items-start justify-start gap-1">
                <div class="font-semibold text-zinc-900">
                  Logame
                </div>
                <div class="text-zinc-900">
                  {{ note.note_message }}
                </div>
              </div>
            </div>
            <div class="text-sm text-zinc-400 text-end">
              @if (note.created_at === note.updated_at) {
                <span>{{ note.created_at | date: 'medium' }}</span>
              } @else {
                <span>{{ note.created_at | date: 'dd/MM/y' }}</span>
                <span> - Editado em {{ note.updated_at | date: 'medium' }}</span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </form>

  <ng-template #footer>
    <p-button label="Cancelar" [text]="true" severity="secondary" (click)="closeDialog(); $event.stopPropagation()" />
    @if (!readAt) {
      <p-button label="Confirmar" (click)="submitDialog()" />
    }
  </ng-template>
</p-dialog>
